import CityLandingPage from './CityLandingPage';
import { cityPages } from '@/mocks/cityPages';

const data = cityPages.find((c) => c.slug === 'electronics-recycling-burbank')!;
const BurbankPage = () => <CityLandingPage data={data} />;
export default BurbankPage;
